export default {
  white: '#ffffff',
  black: '#000000',
  primary: {
    50: '#ffdcb0',
    100: '#ffce93',
    200: '#ffc277',
    300: '#ffb55a',
    400: '#ffac46',
    500: '#f08800',
    600: '#d57900',
    700: '#b46600',
    800: '#965500',
    900: '#7c4600',
  },
  gray: {
    50: '#f8f9fa',
    100: '#f1f3f5',
    200: '#e9ecef',
    300: '#dee2e6',
    400: '#ccd2d8',
    500: '#aeb5ba',
    600: '#888e94',
    650: '#646a70',
    700: '#484f54',
    750: '#3a3e43',
    800: '#32363a',
    850: '#26282b',
    900: '#1f2022',
    950: '#17181a',
  },
  green: {
    400: '#7EC91F',
  },
  yellow: {
    400: '#FFB800',
  },

  transparent: 'transparent',
}
